module.exports = __webpack_public_path__ + "static/media/image_3.734d2b76.png";